import { useCallback, useEffect, useState } from "react";
import colors from "../../../assets/colors.json";
import {
  Icon,
  Input,
  SmallHeader,
  Search,
  TabContainer,
  TabLinkContainer,
} from "../../../pages/Dashboard/styles/dashboard.style";
import PropTypes from "prop-types";
import RequestForm from "./RequestForm";
import { BsSearch } from "react-icons/bs";
import { getLeaveHistories } from "../../../services/user";
import { useSelector } from "react-redux";
import TableLoader from "../../TableLoader";
import { FormateDate } from "../../../utils";
import { NewPagination } from "../../pagination_one/NewPaginations";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableCell, StyledTableRow } from "../../CBT/CBTFirst";
import { toast } from "react-toastify";
import { MdVisibility } from "react-icons/md";
import { StatusBadge } from "../../../pages/student_mgt/stu_mgt.style";

const RequestLeave = ({ showOnlyList }) => {
  const [tab, setTab] = useState(showOnlyList ? 2 : 1);
  const { admToken, user } = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const [showDocModal, setShowDocModal] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState({
    documents: [],
    approvalDocuments: [],
  });
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [filters, setFilters] = useState({
    searchText: "",
    pageSize: 10,
    pageNumber: 1,
  });

  const accountStatus = [
    { id: 0, name: "Pending" },
    { id: 1, name: "Approved" },
    { id: 2, name: "Declined" },
  ];

  const openDocumentPreview = (item) => {
    setSelectedDocs({
      documents: item.documents || [],
      approvalDocuments: item.approvalDocuments || [],
    });
    setShowDocModal(true);
  };

  const getLeaves = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getLeaveHistories(
        admToken,
        user?.staffId,
        filters.searchText,
        filters.pageSize,
        filters.pageNumber,
      );

      if (res.status && res.statusCode === 2) {
        setData(res.data.records || []);
        setTotalPages(res.data.records.totalPages || 1);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [admToken]);

  useEffect(() => {
    getLeaves();
  }, [filters, getLeaves]);

  const handleOpenEdit = (item) => {
    setEditingItem(item);
    setShowModal(true);
  };

  return (
    <>
      {!showOnlyList && (
        <div
          style={{
            display: "inline-flex",
            marginTop: "1.1rem",
            padding: "20px",
          }}
        >
          <div
            role="button"
            style={{
              marginRight: "0.95rem",
              fontWeight: tab === 1 ? "bold" : "500",
              color: tab === 1 ? colors.primary : colors.gray,
              borderBottom: tab === 1 ? `1px solid ${colors.primary}` : "",
              paddingBottom: tab === 1 ? "5px" : "",
            }}
            onClick={() => setTab(1)}
          >
            <p>Request Type</p>
          </div>

          <div
            role="button"
            style={{
              marginRight: "0.95rem",
              fontWeight: tab === 2 ? "bold" : "500",
              color: tab === 2 ? colors.primary : colors.gray,
              borderBottom: tab === 2 ? `1px solid ${colors.primary}` : "",
              paddingBottom: tab === 2 ? "5px" : "",
            }}
            onClick={() => setTab(2)}
          >
            <p>History</p>
          </div>
        </div>
      )}

      <div style={{ marginTop: "0.7rem" }}>
        {tab === 1 && (
          <>
            <SmallHeader
              style={{
                fontWeight: "bold",
                color: "black",
                paddingLeft: "20px",
              }}
            >
              Available Leave Types
            </SmallHeader>
            <RequestForm />
          </>
        )}

        {tab === 2 && (
          <div className="p-5">
            <TabContainer style={{ paddingBottom: "0px" }}>
              <TabLinkContainer bg="#EEE0F1">
                <Input>
                  <Icon>
                    <BsSearch />
                  </Icon>
                  <Search
                    type="text"
                    placeholder="Search"
                    value={filters.searchText}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        searchText: e.target.value,
                        pageNumber: 1,
                      }))
                    }
                  />
                </Input>
              </TabLinkContainer>
              <TableContainer
                pt="0px"
                sx={{ overflow: "hidden", borderRadius: "0px" }}
              >
                <Table
                  sx={{ minWidth: 700, fontFamily: "Gilroy-Regular" }}
                  aria-label="customized table"
                >
                  <TableHead
                    sx={{
                      backgroundColor: "rgba(103, 30, 120, 0.1)",
                      width: "100%",
                    }}
                  >
                    <TableRow sx={{ fontFamily: "Gilroy-Regular" }}>
                      <StyledTableCell>S/N</StyledTableCell>
                      <StyledTableCell>Request Type</StyledTableCell>
                      <StyledTableCell>Duration</StyledTableCell>
                      <StyledTableCell>Start Date</StyledTableCell>
                      <StyledTableCell>End Date</StyledTableCell>
                      <StyledTableCell>Status</StyledTableCell>
                      <StyledTableCell>Applied on </StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ fontFamily: "Gilroy-Regular" }}>
                    {loading ? (
                      <StyledTableRow colSpan={8} align="center">
                        <StyledTableCell>
                          <div className="flex items-center justify-center">
                            <TableLoader />
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : data?.length > 0 ? (
                      data?.map((item, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell>{index + 1}</StyledTableCell>
                          <StyledTableCell>{item.requestType}</StyledTableCell>
                          <StyledTableCell>
                            {item.duration} Days
                          </StyledTableCell>
                          <StyledTableCell>
                            {FormateDate(item.startDate)}
                          </StyledTableCell>
                          <StyledTableCell>
                            {FormateDate(item.endDate)}
                          </StyledTableCell>
                          <StyledTableCell>
                            <StatusBadge status={item.status}>
                              {accountStatus.find((s) => s.id === item.status)
                                ?.name || "Pending"}
                            </StatusBadge>
                          </StyledTableCell>
                          <StyledTableCell>
                            {FormateDate(item.appliedOn)}
                          </StyledTableCell>
                          <StyledTableCell>
                            <div
                              style={{
                                width: "100%",
                                // display: "none",
                                justifyContent: "space-evenly",
                              }}
                            >
                              <button
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  padding: "0.3rem 0.6rem",
                                  backgroundColor: "transparent",
                                  borderColor: colors.primary,
                                  borderWidth: "1px",
                                  borderRadius: "5px",
                                }}
                                className="disabled:cursor-not-allowed!"
                                onClick={() => handleOpenEdit(item)}
                                disabled={item?.status === 1 || loading}
                              >
                                Edit
                              </button>
                            </div>
                          </StyledTableCell>
                          <StyledTableCell>
                            {(item.documents?.length > 0 ||
                              item.approvalDocuments?.length > 0) && (
                              <button
                                onClick={() => openDocumentPreview(item)}
                                className="text-primary hover:scale-110 transition"
                                title="View Documents"
                              >
                                <MdVisibility size={20} />
                              </button>
                            )}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    ) : (
                      <tr colSpan={8} align="center">
                        <p className="text-center p-4">No Available Leaves</p>
                      </tr>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </TabContainer>

            <NewPagination
              pageCount={totalPages}
              currentPage={filters.pageNumber}
              range={3}
              setCurrentPage={(page) =>
                setFilters((prev) => ({
                  ...prev,
                  pageNumber: page,
                }))
              }
            />

            {showModal && (
              <div
                className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
                style={{ zIndex: 1400 }}
              >
                <div className="bg-white rounded-lg p-6 w-full md:w-[600px] h-[95vh] overflow-auto">
                  <div className="flex items-center justify-between">
                    <h2 className="text-xl font-bold mb-4 underline underline-offset-2">
                      Edit Request
                    </h2>
                    <div
                      className="p-2 cursor-pointer bg-gray-200 hover:scale-105 rounded-full"
                      onClick={() => setShowModal(!showModal)}
                    >
                      X
                    </div>
                  </div>
                  <div className="overflow-hidden">
                    <RequestForm editData={editingItem} />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      {showDocModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
          style={{ zIndex: 1500 }}
        >
          <div className="bg-white rounded-lg p-6 w-full md:w-[700px] max-h-[90vh] overflow-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-bold">Supporting Documents</h2>
              <button
                className="bg-gray-200 px-3 py-1 rounded"
                onClick={() => setShowDocModal(false)}
              >
                ✕
              </button>
            </div>

            {/* DOCUMENTS */}
            <div className="mb-6">
              <h3 className="font-semibold mb-2">Document</h3>

              {selectedDocs.documents.length > 0 ? (
                <div className="grid grid-cols-2 gap-4">
                  {selectedDocs.documents.map((url, i) => (
                    <div key={i} className="border rounded p-2">
                      {url.endsWith(".pdf") ? (
                        <iframe
                          src={url}
                          title={`doc-${i}`}
                          className="w-full h-40"
                        />
                      ) : (
                        <img
                          src={url}
                          alt="document"
                          className="w-full h-40 object-cover rounded"
                        />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-500">No document uploaded</p>
              )}
            </div>

            {/* HR DOCUMENTS */}
            <div>
              <h3 className="font-semibold mb-2">HR Document</h3>

              {selectedDocs.approvalDocuments.length > 0 ? (
                <div className="grid grid-cols-2 gap-4">
                  {selectedDocs.approvalDocuments.map((url, i) => (
                    <div key={i} className="border rounded p-2">
                      {url.endsWith(".pdf") ? (
                        <iframe
                          src={url}
                          title={`hr-doc-${i}`}
                          className="w-full h-40"
                        />
                      ) : (
                        <img
                          src={url}
                          alt="hr-document"
                          className="w-full h-40 object-cover rounded"
                        />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-500">
                  No HR document available
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

RequestLeave.propTypes = {
  showOnlyList: PropTypes.bool,
};

RequestLeave.defaultProps = {
  showOnlyList: false,
};

export default RequestLeave;
